import {RoleConst} from '@app/models/role.const';

export class UserUtils {
  static APPLICATION_ROLES: string[] = [RoleConst.ASSISTANT, RoleConst.MEMBER, RoleConst.SECRETARY];
   static getUniversity(roles: string[]): string {
    const rolesFiltered = this.getRoleFiltered(roles);
    if (rolesFiltered.length > 0) {
      const roleSplitted = rolesFiltered[0].split("/", 3);
      return roleSplitted[2];
    }
  }

  static getRoleFiltered(roles: string[]): string[] {
    return roles.filter(role => this.APPLICATION_ROLES.some(appRole => role.startsWith('/' + appRole)));
  }
}
